import {Injectable} from '@angular/core';
import {ErrorLoggingService} from '../../../shared/services/error-logs/error-logging.service';
import {jwtAuthService} from '../../auth/jwtAuthService';

@Injectable({
  providedIn: 'root',
})
export class ModuloPermissoesService {
  constructor(
    private jwt: jwtAuthService,
    private errorLogging: ErrorLoggingService,
  ) {}

  //permissões
  moduloPermissaoUsuario(modulo: any, submodulo: any) {
    let permissaoUsuario = this.jwt.sessaoService();
    const parsedPermissions = JSON.parse(permissaoUsuario.permissions);
    let modulosCadastro;
    let submoduloEncontrado;
    const modules = parsedPermissions?.modules || [];

    if (modules.length > 0) {
      modulosCadastro = modules.find((nomeModulo: any) => nomeModulo.moduleName == modulo);
      submoduloEncontrado = modulosCadastro.subModules.find((item: any) => item.subModuleName == submodulo);
    }

    return submoduloEncontrado;
  }

  permissaoVisualizar(modulo: any, submodulo: any): boolean {
    try {
      let submoduloEncontrado = this.moduloPermissaoUsuario(modulo, submodulo);
      return submoduloEncontrado ? submoduloEncontrado.read : false;
    } catch (error) {
      this.errorLogging.logError(
        `Erro ao verificar permissão de visualizar no módulo ${modulo} e submódulo ${submodulo}`,
        error,
      );
      return false;
    }
  }

  permissaoCadastrarEditar(modulo: any, submodulo: any): boolean {
    try {
      let submoduloEncontrado = this.moduloPermissaoUsuario(modulo, submodulo);
      return submoduloEncontrado ? submoduloEncontrado.edit : false;
    } catch (error) {
      this.errorLogging.logError(
        `Erro ao verificar permissão de cadastrar e editar no módulo ${modulo} e submódulo ${submodulo}`,
        error,
      );

      return false;
    }
  }

  permissaoInativar(modulo: any, submodulo: any): boolean {
    try {
      let submoduloEncontrado = this.moduloPermissaoUsuario(modulo, submodulo);
      return submoduloEncontrado ? submoduloEncontrado.delete : false;
    } catch (error) {
      this.errorLogging.logError(
        `Erro ao verificar permissão de inativar no módulo ${modulo} e submódulo ${submodulo}`,
        error,
      );
      return false;
    }
  }

  podeAcessarRota(url: string): boolean {
    try {
      let permissaoUsuario = this.jwt.sessaoService();
      const parsedPermissions = JSON.parse(permissaoUsuario.permissions);
      const modules = parsedPermissions?.modules || [];

      for (const modulo of modules) {
        if (modulo.subModules) {
          const submoduloEncontrado = modulo.subModules.find(
            (submodulo: any) => submodulo.Entity === url && submodulo.read && submodulo.active,
          );

          if (submoduloEncontrado) {
            return true;
          }
        }
      }

      return false;
    } catch (error) {
      this.errorLogging.logError(`Erro ao verificar permissão para acessar a rota ${url}`, error);
      return false;
    }
  }
}
